import {
  isAccountBalanceChangedPushEvent,
  isAccountBalanceChangedExceptionPushEvent,
  isPayIdStatusChangedPushEvent,
  isWithdrawChannelChangedPushEvent,
  PushEvent,
} from 'tabtouch-push-contract'
import { QueryClient } from '@tanstack/react-query'
import { queryKeys } from './constants'
import { FeedbackBalanceChange } from './FeedbackBalanceChange'
import { FeedbackPayIdStatusChange } from '../Areas/Deposit/Utils/FeedbackPayIdStatusChange'
import { FeedbackWithdrawalChannelChange } from '../Areas/Withdraw/Utils/FeedbackWithdrawalChannelChange'

export const balanceUpdate = (
  payload: PushEvent,
  queryClient: QueryClient,
  onSuccess: () => void
) => {
  const isBalanceChangedSuccess = isAccountBalanceChangedPushEvent(payload)
  const isBalanceChangedError = isAccountBalanceChangedExceptionPushEvent(payload)
  if (!isBalanceChangedSuccess && !isBalanceChangedError) return

  FeedbackBalanceChange(payload)
  if (isBalanceChangedSuccess) {
    onSuccess()
    queryClient.invalidateQueries({
      queryKey: queryKeys.depositInitialData,
    })
    queryClient.invalidateQueries({
      queryKey: queryKeys.withdrawDetails,
    })
  }
}

export const payIdUpdate = (
  payload: PushEvent,
  accountNumber: number,
  queryClient: QueryClient
) => {
  /*
   * We are using a random number to track if the activation
   * event is getting fired over multiple tabs.
   */
  const processId = Math.round(Math.random() * 1e6)
  if (isPayIdStatusChangedPushEvent(payload)) {
    FeedbackPayIdStatusChange(accountNumber, payload.status, processId)
    // Refetch the PayId details
    queryClient.invalidateQueries({
      queryKey: queryKeys.betAccount,
    })
  }
}

export const withdrawChannelUpdate = (payload: PushEvent) => {
  if (isWithdrawChannelChangedPushEvent(payload)) {
    FeedbackWithdrawalChannelChange()
  }
}
